import { FAQ_ITEMS } from './FAQModel';
import FAQView from './FAQView';
import { useFAQViewModel } from './useFAQViewModel';

export const FAQ = () => {
  const { openId, toggleQuestion } = useFAQViewModel();

  return (
    <FAQView
      faqItems={FAQ_ITEMS}
      openId={openId}
      onToggleQuestion={toggleQuestion}
    />
  );
};

export default FAQ;
